import moment from 'moment'

export const getAge = (diff: number) => {
  const duration = moment.duration(diff)
  return duration.format().replace('-', '')
}
